import rootReducer from "./reducers"
import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
function configureStore() {
  return createStore(rootReducer,
    compose(
      applyMiddleware(thunk),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  );
}
export const store = configureStore();


// WEBPACK FOOTER //
// ./src/store/index.js